const yup = require("yup");

const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const phoneRegex = /^\+?[1-9]\d{1,14}$/;

const passwordRegx =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/;

export const newUserSchema = yup
  .object({
    email: yup
      .string()
      .required("Email is required")
      .test("email", "Enter a valid email", (value) => {
        if (!value) return false;
        return emailRegex.test(value);
      }),
    firstName: yup.string(255).required("First name is required"),
    lastName: yup.string(255).required("Last name is required"),
    credit: yup.number().required("Credit is required"),
    role: yup.number().required("Role is required"),
    password: yup
      .string()
      .max(255)
      .matches(
        passwordRegx,
        "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
      ),
  })
  .strict()
  .noUnknown(true);

export const signUpSchema = yup
  .object({
    email: yup
      .string()
      .required("Email is required")
      .test("email", "Enter a valid email", (value) => {
        if (!value) return false;
        return emailRegex.test(value);
      }),
    firstName: yup.string(255).required("First name is required"),
    lastName: yup.string(255).required("Last name is required"),
    phone: yup.string(255).required("Phone is required"),
    password: yup
      .string()
      .max(255)
      .matches(
        passwordRegx,
        "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
      ),
  })
  .strict()
  .noUnknown(true);
